import { createSelector } from '@reduxjs/toolkit';

import { selectAuth } from '@/store/selectors/auth';
import { resolveCanCreateSix, resolveCanManageExternalUsers } from '@/utils/permissions';

export const selectCurrentUserType = createSelector(selectAuth, (authState) => authState.userType);

export const selectCanCreateSix = createSelector(selectCurrentUserType, (userType) =>
  resolveCanCreateSix(userType)
);

export const selectCanManageExternalUsers = createSelector(selectCurrentUserType, (userType) =>
  resolveCanManageExternalUsers(userType)
);
